import { styled } from 'goober'

export const Code = styled('div')`
  padding: 1em;
  background: var(--toolbar);
  font-family: var(--font-mono);
  border-radius: .5rem;
`

export const Hint = styled('p')`
  margin-top: 100vh;
  color: grey;
  opacity: .2;
  border-radius: .5rem;
`
